<script setup>
  import ComponentCategoryBadge from "@components/Badges/CategoryBadge.vue";
  import {MedIcon} from "@pharma4u/medicheck-components";
  import {cn} from "@pharma4u/medicheck-components/utils";

  defineOptions({
    name: "ComponentFoldable",
  });

  defineProps({
    title: {
      type: String,
      default: "DefaultTitle",
    },
    open: {
      type: [Boolean, String],
      default: false,
    },
    badgeLabel: {
      type: [String, Number],
      default: null,
    },
    badgeColor: {
      type: String,
      default: null,
    },
  });
</script>

<template>
  <details class="group" :open="open">
    <summary
      class="-mx-4 flex cursor-pointer items-center border-t-1 border-gray-200 bg-linear-to-b from-gray-100 to-white px-4 py-2 select-none hover:to-gray-100"
      :data-test="getTestId('foldable-trigger')"
    >
      <MedIcon icon="expand_more" :class="cn('mr-1 transition-transform duration-200 group-open:rotate-180')" />

      <div class="flex w-full justify-between space-x-1">
        <span v-text="title" />

        <span v-if="badgeLabel !== null && badgeLabel > 0">
          <ComponentCategoryBadge :label="badgeLabel" :color="badgeColor" />
        </span>
      </div>
    </summary>

    <div class="bg-white pb-2">
      <slot />
    </div>
  </details>
</template>
